import React from 'react';
import Modal, { Styles } from 'react-modal';
import { Button, ButtonSize } from './Button';
import { closeConfirm, handleButtonClick } from '../store/slices/confirmSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';

export const customStylesModal = (maxWidth: string, alignTop: boolean = false): Styles => {
  return {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: alignTop ? 'start' : 'center',
      justifyContent: 'center',
      zIndex: 1000,
      paddingTop: alignTop ? '20px' : '0px',
    },
    content: {
      position: 'relative',
      top: 'auto',
      left: 'auto',
      right: 'auto',
      bottom: 'auto',
      maxWidth: maxWidth,
      width: '90%',
      padding: 0,
      border: 'none',
      background: 'var(--dialog-bg)',
      borderRadius: '0.5rem',
      boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
    },
  };
};

export enum ButtonAlignement {
    row = 'row',
    column = 'column',
}

const ConfirmModal: React.FC = () => {
    const dispatch = useDispatch();
    const { isOpen, title, message, buttons, buttonAlignement } = useSelector((state: RootState) => state.confirm);
    
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => dispatch(closeConfirm())}
            style={customStylesModal('500px')}
            contentLabel="Confirmation Dialog"
    >
      <div className="p-6">
        <h2 className="text-center text-xl font-semibold text-brand-orange">{title}</h2>
        <p className="mt-2 text-center text-gray-600 dark:text-white">{message}</p>
      </div>

      <div 
        className={`
            flex items-center justify-center gap-3 px-6 pb-4
            ${buttonAlignement === ButtonAlignement.row ? 'flex-row' : 'flex-col'}
        `}
    >
        {buttons.map((button) => (
            <Button
                key={button.actionId}
                onClick={() => dispatch(handleButtonClick(button.actionId))}
                variant={button.variant}
                href={button.href}
                target={button.target}
                size={ButtonSize.medium}
            >
                {button.label}
            </Button>
        ))}
      </div>
    </Modal>
  );
};

export default ConfirmModal;